import React from "react";
import { Box, Button, Typography, Paper, Portal } from "@mui/material";
import { styled } from "@mui/material/styles";
import { cookieConsent } from "@/utils/localStore";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Bar = styled(Paper)(({
  theme
}) => ({
  // !important guards against any ancestor that might create a
  // containing block (transform / filter / contain) and turn this
  // into a position:absolute element that participates in layout.
  position: "fixed !important",
  bottom: 16,
  left: 16,
  right: 16,
  zIndex: 1300,
  padding: theme.spacing(2),
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(2),
  border: `2px solid ${theme.palette.primary.main}`,
  // Detach from page layout/paint so mount/unmount cannot reflow siblings.
  contain: "layout paint",
  pointerEvents: "auto"
}));
export default function CookieConsentBar() {
  const [visible, setVisible] = React.useState(false);
  React.useEffect(() => {
    const allowed = cookieConsent.allowed();
    if (!allowed) setVisible(true);
  }, []);
  if (!visible) return null;
  return /*#__PURE__*/_jsx(Portal, {
    children: /*#__PURE__*/_jsxs(Bar, {
      elevation: 3,
      children: [/*#__PURE__*/_jsxs(Box, {
        sx: {
          flex: 1
        },
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "subtitle2",
          fontWeight: 700,
          gutterBottom: true,
          children: "We use cookies to cache data locally"
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "body2",
          color: "text.secondary",
          children: "This ensures faster page loading and a better user experience. You can decline to continue without local caching."
        })]
      }), /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: "flex",
          gap: 1
        },
        children: [/*#__PURE__*/_jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: () => {
            cookieConsent.set({
              functional: true
            });
            setVisible(false);
          },
          children: "Accept"
        }), /*#__PURE__*/_jsx(Button, {
          variant: "outlined",
          color: "inherit",
          onClick: () => {
            cookieConsent.set({
              functional: false
            });
            setVisible(false);
          },
          children: "Decline"
        })]
      })]
    })
  });
}